import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as R from 'ramda';
import { OutputType } from 'src/components/drug/OutputCompareTableColumns';
import { isKeyOfObject, ItemableType } from 'src/types';
import { OutputStatus } from 'src/types/drug';
import { utcDateString2localDateString } from '.';
import { default as drugsConstant, default as MedicineConstant } from '../constants/drugs';
import { getUserInfoFromClient } from './client';

var mergeRecord = function mergeRecord(a, b) {
  var amount = a.amount + b.amount;
  return _objectSpread(_objectSpread({}, a), {}, {
    amount: amount,
    medicineCount: getMedicineCount(a.days, amount, a.package_unit),
    returned: !!a.returned || !!b.returned
  });
};

export var getOutputStatusFromDispensationOrder = R.pipe(R.pathOr([], ['dispensation_order_items']), R.map(R.prop('output_status')), R.uniq, function (outputStatuses) {
  if (!(outputStatuses !== null && outputStatuses !== void 0 && outputStatuses.length)) {
    return OutputStatus.output_none;
  } else if (outputStatuses.length === 1) {
    return outputStatuses[0];
  } else if (outputStatuses.includes(OutputStatus.output_some) || outputStatuses.includes(OutputStatus.output_all)) {
    return OutputStatus.output_some;
  } else {
    return OutputStatus.output_none;
  }
});
export var normalizeMedicineRecordForPDF = function normalizeMedicineRecordForPDF(records) {
  // same medicine different batch_name will produce multiple records,
  // we need to merge these records which have the same english_name, days, frequency and single_amount
  var medicineMap = {};

  var _loop = function _loop(i) {
    var cur = records[i];
    var mapKey = cur.english_name;
    var mergedRecords = medicineMap[mapKey] || [];
    var isExist = !!(mergedRecords !== null && mergedRecords !== void 0 && mergedRecords.length);
    var toMergeIndex = R.findIndex(function (item) {
      return cur.days === item.days && cur.frequency === item.frequency && cur.single_amount === item.single_amount;
    }, mergedRecords);
    var recordWillMerged = mergedRecords === null || mergedRecords === void 0 ? void 0 : mergedRecords[toMergeIndex];

    if (isExist) {
      medicineMap[mapKey] = toMergeIndex === -1 ? R.append(cur, mergedRecords) : R.update(toMergeIndex, mergeRecord(recordWillMerged, cur), mergedRecords);
    } else {
      medicineMap[mapKey] = [cur];
    }
  };

  for (var i = 0; i < records.length; i++) {
    _loop(i);
  }

  var finalRecords = R.pipe(R.values, R.flatten, R.map(transformReturned))(medicineMap);
  return finalRecords;
};
export var transformReturned = function transformReturned(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    returned: item.returned ? '退藥' : '－'
  });
};
export var getName = function getName(user) {
  var _user$last_name, _user$first_name;

  return "".concat((_user$last_name = user === null || user === void 0 ? void 0 : user.last_name) !== null && _user$last_name !== void 0 ? _user$last_name : '').concat((_user$first_name = user === null || user === void 0 ? void 0 : user.first_name) !== null && _user$first_name !== void 0 ? _user$first_name : '');
};
export var getFrequencyUsage = function getFrequencyUsage(frequency) {
  var _MedicineConstant$FRE;

  return ((_MedicineConstant$FRE = MedicineConstant.FREQUENCY_RATIO_MAPPING[frequency]) === null || _MedicineConstant$FRE === void 0 ? void 0 : _MedicineConstant$FRE.text) || '';
};
export var getMedicineName = function getMedicineName(medicine) {
  return "".concat(medicine.english_name || '', " / ").concat(medicine.chinese_name || '');
};
export var getSingleAmountUsage = function getSingleAmountUsage(single_amount, minimum_unit) {
  return "\u6BCF\u6B21 ".concat(single_amount || '', " ").concat(minimum_unit || '');
};
export var getMedicineCount = function getMedicineCount(days, amount, package_unit) {
  return "".concat(days || '', " \u5929 / ").concat(amount || '', " ").concat(package_unit || '');
};
export var getPdfDataFromDispensationOrder = function getPdfDataFromDispensationOrder(dispensation_order) {
  var userInfo = getUserInfoFromClient(R.propOr({}, 'client', dispensation_order));
  var soap = R.pathOr({}, ['prescription', 'soap'], dispensation_order);
  var doctorId = R.pathOr('', ['data', 'doctor_id'], soap);
  var doctor = R.pathOr('', ['data', 'doctor_name'], soap);
  var date = R.pathOr('', ['date'], soap);
  var soapDate = date ? utcDateString2localDateString(date, 'YYYY/MM/DD') : '';
  var pdfData = R.pipe(R.pathOr([], ['output_orders']), getPdfDataFromOutputOrders({
    doctor: doctor,
    doctorId: doctorId,
    soapDate: soapDate,
    userInfo: userInfo
  }))(dispensation_order);
  return pdfData;
};
export var getPdfDataFromOutputOrders = function getPdfDataFromOutputOrders(others) {
  return R.chain(function (order) {
    return R.map(function (outgoing) {
      var medicine = R.pathOr({}, ['medicine', 'identifier'], outgoing);
      var dispensation_order_item = R.pathOr({}, ['dispensation_order_item'], outgoing);
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, others), R.pick(['serial_number', 'date'], order)), R.pick(['amount'], outgoing)), R.pick(['frequency', 'days', 'single_amount'], dispensation_order_item)), R.pick(['english_name', 'compliance', 'indications', 'side_effect', 'package_unit'], medicine)), {}, {
        date: utcDateString2localDateString(order.date, 'YYYY/MM/DD'),
        compliance: R.pathOr('－', ['compliance'], dispensation_order_item),
        returned: R.path(['returned'], dispensation_order_item),
        category: R.pathOr('', ['medicine', 'category'], outgoing),
        user_name: getName(order === null || order === void 0 ? void 0 : order.user),
        pharmacist_user_id: order === null || order === void 0 ? void 0 : order.user_id,
        frequencyUsage: getFrequencyUsage(dispensation_order_item.frequency),
        medicineName: getMedicineName(medicine),
        singleAmountUsage: getSingleAmountUsage(dispensation_order_item.single_amount, medicine.minimum_unit),
        medicineCount: getMedicineCount(dispensation_order_item.days, outgoing.amount, medicine.package_unit)
      });
    }, R.pathOr([], ['outgoings'], order));
  });
};
export function getMedicineCategoryName(category) {
  var _MedicineConstant$MAP;

  return ((_MedicineConstant$MAP = MedicineConstant.MAP_MEDICINE_CATEGORY_FROM_VALUE[category]) === null || _MedicineConstant$MAP === void 0 ? void 0 : _MedicineConstant$MAP.text) || '未知';
}
export function getMedicineCategory(category) {
  return R.pipe(R.values, R.find(function (medicine) {
    return medicine.value === category;
  }), R.prop('key'))(MedicineConstant.MEDICINE_CATEGORY);
}
export function getMedicineCategoryTranslation(category, t) {
  return t(MedicineConstant.MAP_MEDICINE_CATEGORY_FROM_VALUE[category].i18n, MedicineConstant.MAP_MEDICINE_CATEGORY_FROM_VALUE[category].text);
}
export function sortMedicineCategory(a, b) {
  var priorityA = MedicineConstant.CATEGORY_ORDER_MAP[a];
  var priorityB = MedicineConstant.CATEGORY_ORDER_MAP[b];

  if (priorityA === priorityB) {
    return 0;
  } else if (priorityA === undefined) {
    return 1;
  } else if (priorityB === undefined) {
    return -1;
  } else {
    return priorityA - priorityB;
  }
} // sort by category asc, price desc, manufacturer asc

export function sortCatalogList(a, b) {
  var _a$manufacturer;

  if (a.category !== b.category) {
    return sortMedicineCategory(a.category, b.category);
  }

  if (a.price !== b.price) {
    return b.price - a.price;
  }

  return a === null || a === void 0 ? void 0 : (_a$manufacturer = a.manufacturer) === null || _a$manufacturer === void 0 ? void 0 : _a$manufacturer.localeCompare(b === null || b === void 0 ? void 0 : b.manufacturer);
}
export function getMedicineAmount(_ref) {
  var days = _ref.days,
      frequency_ratio = _ref.frequency_ratio,
      single_amount = _ref.single_amount,
      package_amount = _ref.package_amount;

  if (!package_amount) {
    return 0;
  }

  return parseFloat(Math.ceil(days * frequency_ratio * single_amount / package_amount).toFixed(3));
}
export function getTotalAmount(_ref2) {
  var days = _ref2.days,
      frequency_ratio = _ref2.frequency_ratio,
      single_amount = _ref2.single_amount;
  return parseFloat((Number(days) * Number(frequency_ratio) * Number(single_amount)).toFixed(3));
}
export var reCalculateMedicineAfterSingleAmountChange = function reCalculateMedicineAfterSingleAmountChange(medicine, single_amount) {
  return _objectSpread(_objectSpread({}, medicine), {}, {
    single_amount: single_amount,
    total_amount: getTotalAmount({
      days: medicine.days,
      frequency_ratio: medicine.frequency_ratio,
      single_amount: single_amount
    }),
    medicine_amount: getMedicineAmount({
      days: medicine.days,
      frequency_ratio: medicine.frequency_ratio,
      single_amount: single_amount,
      package_amount: medicine.package_amount
    })
  });
};
export var reCalculateMedicineAfterDaysChange = function reCalculateMedicineAfterDaysChange(medicine, days) {
  return _objectSpread(_objectSpread({}, medicine), {}, {
    days: days,
    total_amount: getTotalAmount({
      days: days,
      frequency_ratio: medicine.frequency_ratio,
      single_amount: medicine.single_amount
    }),
    medicine_amount: getMedicineAmount({
      days: days,
      frequency_ratio: medicine.frequency_ratio,
      single_amount: medicine.single_amount,
      package_amount: medicine.package_amount
    })
  });
};
export var reCalculateMedicineAfterFrequencyChange = function reCalculateMedicineAfterFrequencyChange(medicine, frequency) {
  if (!isKeyOfObject(frequency, drugsConstant.frequency_ratio)) {
    return medicine;
  }

  var frequency_ratio = drugsConstant.frequency_ratio[frequency];
  return _objectSpread(_objectSpread({}, medicine), {}, {
    frequency: frequency,
    frequency_ratio: frequency_ratio,
    total_amount: getTotalAmount({
      days: medicine.days,
      frequency_ratio: frequency_ratio,
      single_amount: medicine.single_amount
    }),
    medicine_amount: getMedicineAmount({
      days: medicine.days,
      frequency_ratio: frequency_ratio,
      single_amount: medicine.single_amount,
      package_amount: medicine.package_amount
    })
  });
};
export var aggregateAmount = function aggregateAmount(_ref3) {
  var calcTotalAmount = _ref3.calcTotalAmount;
  return R.mapObjIndexed(R.reduce(function (acc, cur) {
    return _objectSpread(_objectSpread(_objectSpread({}, acc), cur), {}, {
      updated_at: R.max(R.propOr('', 'updated_at', acc), R.propOr('', 'updated_at', cur)),
      amount: R.add(R.propOr(0, 'amount', acc), R.propOr(0, 'amount', cur)),
      total_amount: R.add(R.propOr(0, 'total_amount', acc), calcTotalAmount ? getTotalAmount({
        days: (cur === null || cur === void 0 ? void 0 : cur.days) || 0,
        frequency_ratio: (cur === null || cur === void 0 ? void 0 : cur.frequency_ratio) || 0,
        single_amount: (cur === null || cur === void 0 ? void 0 : cur.single_amount) || 0
      }) : R.propOr(0, 'total_amount', cur)),
      medicine_amount: R.add(R.propOr(0, 'medicine_amount', acc), R.propOr(0, 'medicine_amount', cur))
    });
  }, {}));
};
export var groupMedicine = R.groupBy(function (item) {
  return R.join('_', [R.pathOr('', ['english_name'], item).replace(/\s/g, '-'), R.pathOr('', ['days'], item), R.pathOr('', ['frequency'], item), R.pathOr('', ['single_amount'], item)]);
});
export var normalizeMedicinesFromDispensationOrder = function normalizeMedicinesFromDispensationOrder(dispensation_order) {
  return R.chain(function (outputOrder) {
    return R.chain(function (outgoing) {
      return _objectSpread(_objectSpread(_objectSpread({}, Object(R.pickAll(['english_name', 'chinese_name', 'package_unit', 'minimum_unit', 'package_amount'], R.pathOr({}, ['medicine', 'identifier'], outgoing)))), Object(R.pickAll(['compliance', 'single_amount', 'days', 'frequency', 'returned', 'frequency_ratio', 'archived', 'medicine_amount', 'total_amount'], R.propOr({}, 'dispensation_order_item', outgoing)))), {}, {
        category: R.pathOr('', ['medicine', 'identifier', 'category'], outgoing),
        amount: R.pathOr(0, ['amount'], outgoing),
        updated_at: R.pathOr(0, ['updated_at'], outgoing),
        medicine_id: R.pathOr(0, ['medicine', 'id'], outgoing),
        itemable_id: R.pathOr(0, ['medicine', 'id'], outgoing),
        itemable_type: ItemableType['Pharmacy::Medicine'] // only 'Pharmacy::Medicine' will be exist on dispensation order item

      });
    }, R.pathOr([], ['outgoings'], outputOrder));
  }, R.pathOr([], ['output_orders'], dispensation_order));
};
export var normalizeMedicineFromMedicationOrder = function normalizeMedicineFromMedicationOrder(medication_order) {
  var _medication_order$ite;

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, R.pickAll(['package_unit', 'minimum_unit', 'english_name', 'chinese_name', 'package_amount'], R.pathOr({}, ['itemable', 'identifier'], medication_order))), R.pickAll(['english_name', 'chinese_name', 'serial_code'], R.pathOr({}, ['itemable'], medication_order))), R.pickAll(['compliance', 'updated_at', 'single_amount', 'days', 'frequency', 'frequency_ratio', 'medicine_amount', 'total_amount', 'itemable_type', 'itemable_id'], medication_order)), {}, {
    medicine_id: R.pathOr('', ['itemable', 'id'], medication_order),
    amount: R.pathOr(0, ['medicine_amount'], medication_order),
    category: R.pathOr((medication_order === null || medication_order === void 0 ? void 0 : (_medication_order$ite = medication_order.itemable) === null || _medication_order$ite === void 0 ? void 0 : _medication_order$ite.category) || '', ['itemable', 'identifier', 'category'], medication_order)
  });
};
export var getComparedOutgoings = function getComparedOutgoings(prescription, dispensation_order, t) {
  var medicationOrders = R.pipe(R.pathOr([], ['medication_orders']), R.map(normalizeMedicineFromMedicationOrder), groupMedicine, R.reject(R.isNil), aggregateAmount({
    calcTotalAmount: false
  }))(prescription);
  var dispensationOrderItems = R.pipe(normalizeMedicinesFromDispensationOrder, groupMedicine, R.reject(R.isNil), aggregateAmount({
    calcTotalAmount: true
  }))(dispensation_order);
  var keys = R.uniq(R.concat(R.keys(medicationOrders), R.keys(dispensationOrderItems)));
  var compared_orders = R.map(function (key) {
    var _medicationOrders$key, _dispensationOrderIte;

    var medicationOrder = (_medicationOrders$key = medicationOrders[key]) !== null && _medicationOrders$key !== void 0 ? _medicationOrders$key : {
      _disable: true
    };
    var outgoing = (_dispensationOrderIte = dispensationOrderItems[key]) !== null && _dispensationOrderIte !== void 0 ? _dispensationOrderIte : {
      _disable: true
    };
    var english_name = R.propOr('', 'english_name', medicationOrder) || R.propOr('', 'english_name', outgoing);
    var chinese_name = R.propOr('', 'chinese_name', medicationOrder) || R.propOr('', 'chinese_name', outgoing);
    var name = "".concat(english_name, " / ").concat(chinese_name);
    return {
      name: name,
      subRows: [_objectSpread(_objectSpread({}, medicationOrder), {}, {
        type: OutputType.prescription,
        name: t('common:normal.doctorPrescription', '醫師處方')
      }), _objectSpread(_objectSpread({}, outgoing), {}, {
        type: OutputType.outgoing,
        name: t('common:normal.receivedOutput', '領藥出庫')
      })]
    };
  }, keys);
  return compared_orders;
};
export var mapProductToPrescription = function mapProductToPrescription(product) {
  return {
    itemable_id: product.itemable_id,
    itemable_type: product.itemable_type,
    single_amount: product.single_amount,
    serial_code: product.serial_code,
    frequency: product.frequency,
    frequency_ratio: product.frequency_ratio,
    days: product.days,
    total_amount: 0,
    medicine_amount: 0,
    compliance: product.basic_compliance,
    medicine_id: product.id,
    english_name: product.english_name,
    chinese_name: product.chinese_name,
    package_amount: product.package_amount,
    package_unit: product.unit,
    minimum_unit: product.minimum_unit,
    category: product.category
  };
};
export var mapPrescription = function mapPrescription(item) {
  var _item$itemable_id, _item$days, _item$total_amount, _item$frequency_ratio, _item$single_amount, _item$itemable$serial, _item$itemable, _item$medicine_amount, _item$itemable_type, _item$compliance, _item$frequency, _item$itemable$id, _item$itemable2, _item$itemable$englis, _item$itemable3, _item$itemable$chines, _item$itemable4, _item$itemable$packag, _item$itemable5, _item$itemable$packag2, _item$itemable6, _item$itemable$minimu, _item$itemable7, _item$itemable$catego, _item$itemable8;

  var fallbackValue = item.itemable_type === ItemableType['MedicalCare::Examination'] ? '' : 0;
  return {
    id: item.id,
    itemable_id: (_item$itemable_id = item.itemable_id) !== null && _item$itemable_id !== void 0 ? _item$itemable_id : 0,
    days: (_item$days = item.days) !== null && _item$days !== void 0 ? _item$days : fallbackValue,
    total_amount: (_item$total_amount = item.total_amount) !== null && _item$total_amount !== void 0 ? _item$total_amount : fallbackValue,
    frequency_ratio: (_item$frequency_ratio = item.frequency_ratio) !== null && _item$frequency_ratio !== void 0 ? _item$frequency_ratio : fallbackValue,
    single_amount: (_item$single_amount = item.single_amount) !== null && _item$single_amount !== void 0 ? _item$single_amount : fallbackValue,
    serial_code: (_item$itemable$serial = (_item$itemable = item.itemable) === null || _item$itemable === void 0 ? void 0 : _item$itemable.serial_code) !== null && _item$itemable$serial !== void 0 ? _item$itemable$serial : '',
    medicine_amount: (_item$medicine_amount = item.medicine_amount) !== null && _item$medicine_amount !== void 0 ? _item$medicine_amount : fallbackValue,
    itemable_type: (_item$itemable_type = item.itemable_type) !== null && _item$itemable_type !== void 0 ? _item$itemable_type : '',
    compliance: (_item$compliance = item.compliance) !== null && _item$compliance !== void 0 ? _item$compliance : '',
    frequency: (_item$frequency = item.frequency) !== null && _item$frequency !== void 0 ? _item$frequency : '',
    medicine_id: (_item$itemable$id = item === null || item === void 0 ? void 0 : (_item$itemable2 = item.itemable) === null || _item$itemable2 === void 0 ? void 0 : _item$itemable2.id) !== null && _item$itemable$id !== void 0 ? _item$itemable$id : 0,
    english_name: (_item$itemable$englis = item === null || item === void 0 ? void 0 : (_item$itemable3 = item.itemable) === null || _item$itemable3 === void 0 ? void 0 : _item$itemable3.english_name) !== null && _item$itemable$englis !== void 0 ? _item$itemable$englis : '',
    chinese_name: (_item$itemable$chines = item === null || item === void 0 ? void 0 : (_item$itemable4 = item.itemable) === null || _item$itemable4 === void 0 ? void 0 : _item$itemable4.chinese_name) !== null && _item$itemable$chines !== void 0 ? _item$itemable$chines : '',
    package_amount: (_item$itemable$packag = item === null || item === void 0 ? void 0 : (_item$itemable5 = item.itemable) === null || _item$itemable5 === void 0 ? void 0 : _item$itemable5.package_amount) !== null && _item$itemable$packag !== void 0 ? _item$itemable$packag : 0,
    package_unit: (_item$itemable$packag2 = item === null || item === void 0 ? void 0 : (_item$itemable6 = item.itemable) === null || _item$itemable6 === void 0 ? void 0 : _item$itemable6.package_unit) !== null && _item$itemable$packag2 !== void 0 ? _item$itemable$packag2 : '',
    minimum_unit: (_item$itemable$minimu = item === null || item === void 0 ? void 0 : (_item$itemable7 = item.itemable) === null || _item$itemable7 === void 0 ? void 0 : _item$itemable7.minimum_unit) !== null && _item$itemable$minimu !== void 0 ? _item$itemable$minimu : '',
    category: (_item$itemable$catego = item === null || item === void 0 ? void 0 : (_item$itemable8 = item.itemable) === null || _item$itemable8 === void 0 ? void 0 : _item$itemable8.category) !== null && _item$itemable$catego !== void 0 ? _item$itemable$catego : ''
  };
};